(function (w, $, ps) {

    const assetId = '~/Controls/Site/LanguageCurrencySelector.min.js';
    const cookieHandler = w.cms && w.cms.cookie ? w.cms : $;

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    w.umwAssets[assetId].forEach(ctx => {

        const cont = $('#' + ctx.mainPanelId);

        $('li.Language a', cont).click(function(e) {
            e.preventDefault();

            const t = $(this);
            const locale = t.data('locale');

            if (locale === ctx.activeLocale) {
                return false;
            }

            cookieHandler.setLocaleCookie(locale);

            window.location = window.location;

            return false;
        });

        $('li.Currency a', cont).click(function(e) {
            e.preventDefault();

            const t = $(this);
            const currency = t.data('currency');

            if (currency === ctx.activeCurrency) {
                return false;
            }

            cookieHandler.setCurrencyCookie(currency);

            window.location = window.location;

            return false;
        });

        function updateSelectedCurrency(currency) {
            if (!currency) {
                return;
            }
            ctx.activeCurrency = currency;
            var lis = $('li.Currency:has(a[data-currency])');
            lis.removeClass('Selected');
            lis.has('a[data-currency=' + currency + ']').addClass('Selected');
        }

        ps.subscribe('cookie.currency-cookie-set', subscribeCurrencyCookie.bind(this));

        function subscribeCurrencyCookie(channel, currency) {
            if (currency !== ctx.activeCurrency) {
                updateSelectedCurrency(currency);
            }
        }

        const cookieCurrency = cookieHandler.getCurrencyCookie();
        if (cookieCurrency !== ctx.activeCurrency) {
            updateSelectedCurrency(cookieCurrency);
        }
    });

})(window, jQuery, window.PubSub)